<template>
    <a href="mailto:" v-if="emailAddress">
        <template v-if="displayName">{{displayName}}</template>
        <template v-else>{{emailAddress}}</template>
    </a>
    <span v-else-if="displayName">
        {{displayName}}
    </span>
    <span v-else>&nbsp;</span>
</template>

<script>
    export default {
        props: {
            emailAddress: {
                type: String,
                required: false,
                default: null
            },
            displayName: {
                type: String,
                required: false,
                default: null
            }
        }
    }
</script>
